import React from 'react';
import { connect } from 'react-redux';
import { FaCheck } from 'react-icons/fa';

const SuccessPopup = ({ closePopup, lang }) => {
  const language = lang.internet_channels.add_m3u8_list;
  const handleSubmit = () => {
    closePopup();
    window.location.href = '/internetTV/addM3U8list';
  };
  
  return (
    <div className='mini_popup' onClick={closePopup}>
      <div className='mini_popup_holder' onClick={e => e.stopPropagation()}>
        <FaCheck />
        <p>{language.success_text}</p>
        <button onClick={handleSubmit}>{language.success_btn}</button>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  lang: state.selectedLanguage
})

export default connect(mapStateToProps)(SuccessPopup);
